// functions/lib/report/dates.ts
//
// Jours du rapport quotidien. Le jour du rapport est la date du matin en heure de
// Paris, heure d'été comprise. Les calculs sur des dates YYYY-MM-DD se font en UTC :
// un jour calendaire y dure toujours 24 h, quel que soit le fuseau de la machine
// (Europe/Paris sur le Mac, UTC sur le robot).

/**
 * Jours relus par chaque collecte du matin : la fenêtre va de J−7 à J−1, J étant le jour de Paris
 * de la collecte. Les chiffres arrivent en retard (SKAdNetwork, App Store à J-2, réattributions).
 */
export const BACKFILL_DAYS = 7

const PARIS_DAY = new Intl.DateTimeFormat('fr-CA', {
  timeZone: 'Europe/Paris',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
})

/** Jour calendaire de Paris (YYYY-MM-DD) à l'instant `now`. */
export function parisDate(now: Date): string {
  const parts = PARIS_DAY.formatToParts(now)
  const part = (type: Intl.DateTimeFormatPartTypes): string => {
    const value = parts.find((p) => p.type === type)?.value
    if (value === undefined) throw new Error(`parisDate : partie ${type} absente`)
    return value
  }
  return `${part('year')}-${part('month')}-${part('day')}`
}

/** Décale une date YYYY-MM-DD de `n` jours (négatif pour reculer). */
export function addDays(date: string, n: number): string {
  const d = new Date(`${date}T00:00:00.000Z`)
  d.setUTCDate(d.getUTCDate() + n)
  return d.toISOString().slice(0, 10)
}

/** Jours de `from` à `to`, bornes incluses ; vide si `from` est après `to`. */
export function dateRange(from: string, to: string): string[] {
  const days: string[] = []
  for (let day = from; day <= to; day = addDays(day, 1)) days.push(day)
  return days
}
